
export function initCalendarView() {
    const view = document.querySelector('.calendar') as HTMLDivElement;
    const toggleView = document.getElementById('toggleView') as HTMLButtonElement;

    if (toggleView) {
        toggleView.addEventListener('click',
            () => {
                toggleView.classList.toggle('toggleView--active');
                view.classList.toggle('calendar--compact-view');
            });
    }

    try {
        if (dotvvm.viewModels.root.viewModel.IsToggleEnabled()) {
            toggleView.classList.toggle('toggleView--active');
            view.classList.toggle('calendar--compact-view');
        }
    } catch (e) {

    }
}